import React, { useState } from "react";
import { P_Props } from "./BannerList.type";
import { BannerForm, BannerPublishForm } from "../../..";
import { FloatingButton, Loading, Notification, Pulse } from "../../../../components";
import { CustomButton, CustomStatus } from "../../../../components";
import { EditIcon, DeleteIcon } from "../../../../icons";

import InfiniteScroll from "react-infinite-scroller";
import { Dialog, InputAdornment, TextField, Button } from "@material-ui/core";
import { PriorityHigh as PriorityHighIcon, Search } from "@material-ui/icons";
import { BannerStatus, BannerOutputModel } from "../../../../../models";

const BannerListPresenter: React.FC<P_Props> = (props) => {
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [bannerDelete, setBannerDelete] = useState<BannerOutputModel | undefined>();
  const [visiblePublishForm, setVisiblePublishForm] = useState<boolean>(false);

  const toggleDeleteModal = (banner) => {
    if (banner) {
      setBannerDelete(banner);
    }
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  return (
    <>
      <div className="banner-listing">
        <div className="banner-listing__content">
          <div className="banner-listing__content__header">
            <div className="banner-listing__content__header__title">All Banners</div>
            <div className="banner-listing__content__header__actions">
              <div className="banner-listing__content__header__actions--search">
                <TextField
                  placeholder="Search by name"
                  variant="outlined"
                  className="search-input"
                  inputProps={{ className: "input" }}
                  InputProps={{
                    // style: { fontSize: "1.4rem" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search className="icon" />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    props.onSearch(e.target.value);
                  }}
                />
              </div>
              <Button
                style={{
                  backgroundColor: "#6658F3",
                  color: "#fff",
                  textTransform: "none",
                  marginLeft: "1.6rem",
                  fontSize: "1.6rem",
                  width: "13.9rem",
                }}
                onClick={() => {
                  setVisiblePublishForm(true);
                }}
                disabled={props.fetchedBanner.loading}
              >
                Publish Banner
              </Button>
            </div>
          </div>
          <div className="banner-listing__content__list">
            <div className="banner-listing__content__list__header">
              <div className="text banner-listing__content__list__name">Banner title</div>
              <div className="text banner-listing__content__list__status">Status</div>
              <div className="text banner-listing__content__list__actions"></div>
            </div>
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedBanner.loading && props.fetchedBanner.totalPages > props.fetchedBanner.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedBanner.data.length) && props.fetchedBanner.loading && <Loading />}
              {props.fetchedBanner.data.map((banner) => {
                return (
                  <div key={banner.id} className="banner-listing__content__list__item">
                    <div
                      className="banner-text banner-listing__content__list__name"
                      onClick={() => {
                        props.openBannerFormModal(banner.code);
                      }}
                    >
                      {banner.title}
                    </div>
                    <div className="banner-text banner-listing__content__list__status">
                      <CustomStatus
                        color={banner.status === BannerStatus.ACTIVE ? "#08C4E3" : "#BDC6D7"}
                        title={banner.status}
                        style={{ textTransform: "capitalize" }}
                      />
                    </div>
                    <div className="banner-text banner-listing__content__list__actions">
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          props.openBannerFormModal(banner.code);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <EditIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        }
                      />
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          toggleDeleteModal(banner);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        }
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedBanner.data.length) && props.fetchedBanner.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <FloatingButton
        visible={false}
        onClickPrimary={() => {
          props.openBannerFormModal();
        }}
        btns={[]}
      />

      <Dialog fullScreen open={props.visibleBannerForm}>
        <BannerForm
          // languageId={props.visibleSolutionId}
          bannerCode={props.visibleBannerCode}
          onCancel={() => {
            props.closeBannerFormModal();
          }}
          onComplete_Create={() => {
            props.closeBannerFormModal();
            props.reloadListingPage();
          }}
          onComplete_Update={() => {
            props.closeBannerFormModal();
            props.reloadListingPage();
          }}
          onComplete_Delete={() => {
            props.closeBannerFormModal();
            props.reloadListingPage();
          }}
        />
      </Dialog>

      <Dialog fullScreen open={visiblePublishForm}>
        {visiblePublishForm && (
          <BannerPublishForm
            onSave={() => {
              props.reloadListingPage();
              setVisiblePublishForm(false);
            }}
            onCancel={() => {
              setVisiblePublishForm(false);
              props.closeBannerFormModal();
            }}
            fetchedData={props.fetchedBanner}
          />
        )}
      </Dialog>

      {/* Delete warning modal */}
      <Notification
        visible={visibleDeleteModal}
        title="Delete Banner"
        subTitle={`Are you sure you want to delete “${bannerDelete?.title}“ banner? This action cannot be undone.`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="banner-listing__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal(bannerDelete);
              }}
            >
              Cancel
            </button>
            <button
              className="banner-listing__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteModal(bannerDelete);
                if (bannerDelete?.code) {
                  props.onDeleteBanner(bannerDelete.code);
                }
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default BannerListPresenter;
